import { TERRITORY } from "$routes/_lib/constants";
import { defineMessage } from "react-intl";

export type AddressLine = Record<string, ReturnType<typeof defineMessage>>;

export const addressLine1: AddressLine = {
  [TERRITORY.KENYA]: defineMessage({
    id: "patient.addressSection.addressLine1.kenya",
    defaultMessage: "County",
  }),
  [TERRITORY.NIGERIA]: defineMessage({
    id: "patient.addressSection.addressLine1.nigeria",
    defaultMessage: "State",
  }),
  [TERRITORY.PAKISTAN]: defineMessage({
    id: "patient.addressSection.addressLine1.pakistan",
    defaultMessage: "Province",
  }),
  [TERRITORY.LIBERIA]: defineMessage({
    id: "patient.addressSection.addressLine1.liberia",
    defaultMessage: "County",
  }),
};

export const addressLine2: AddressLine = {
  [TERRITORY.KENYA]: defineMessage({
    id: "patient.addressSection.addressLine2.kenya",
    defaultMessage: "Sub County",
  }),
  [TERRITORY.NIGERIA]: defineMessage({
    id: "patient.addressSection.addressLine2.nigeria",
    defaultMessage: "LGA",
  }),
  [TERRITORY.PAKISTAN]: defineMessage({
    id: "patient.addressSection.addressLine2.pakistan",
    defaultMessage: "District",
  }),
  [TERRITORY.LIBERIA]: defineMessage({
    id: "patient.addressSection.addressLine2.liberia",
    defaultMessage: "District",
  }),
};

export const addressLine3: AddressLine = {
  [TERRITORY.KENYA]: defineMessage({
    id: "patient.addressSection.addressLine3.kenya",
    defaultMessage: "Ward",
  }),
  [TERRITORY.NIGERIA]: defineMessage({
    id: "patient.addressSection.addressLine3.nigeria",
    defaultMessage: "City/Town",
  }),
  [TERRITORY.PAKISTAN]: defineMessage({
    id: "patient.addressSection.addressLine3.pakistan",
    defaultMessage: "City/Town",
  }),
  [TERRITORY.LIBERIA]: defineMessage({
    id: "patient.addressSection.addressLine3.liberia",
    defaultMessage: "City/Town",
  }),
};

export const addressLine4: AddressLine = {
  [TERRITORY.KENYA]: defineMessage({
    id: "patient.addressSection.addressLine4.kenya",
    defaultMessage: "Village/Estate/Landmark",
  }),
  [TERRITORY.NIGERIA]: defineMessage({
    id: "patient.addressSection.addressLine4.nigeria",
    defaultMessage: "Street Address/Landmark",
  }),
  [TERRITORY.PAKISTAN]: defineMessage({
    id: "patient.addressSection.addressLine4.pakistan",
    defaultMessage: "Postal/Street Address/Landmark",
  }),
  [TERRITORY.LIBERIA]: defineMessage({
    id: "patient.addressSection.addressLine4.liberia",
    defaultMessage: "Street Address/Landmark",
  }),
};
